import request from '@/utils/request'
import {guid} from "@/utils/ruoyi";


// 查询商品列表
export function listGoods(query) {
  return request({
    url: '/goodsXunjia/goodsXunjia/list',
    method: 'get',
    params: query
  })
}

// 查询商品分页
export function pageGoods(data) {
  data.date=guid()
  return request({
    url: '/goodsXunjia/goodsXunjia/page',
    method: 'post',
    data: data
  })
}
// 查询商品分页
export function activePage(data) {
  data.date=guid()
  return request({
    url: '/goodsXunjia/goodsXunjia/activePage',
    method: 'post',
    data: data
  })
}
// 查询商品详细
export function getGoods(data) {
  return request({
    url: '/goodsXunjia/goodsXunjia/detail',
    method: 'get',
    params: data
  })
}
// 查询商品详细
export function adminLogin() {
  return request({
    url: '/goodsXunjia/goodsXunjia/adminLogin',
    method: 'get',
  })
}
// 新增商品
export function addGoods(data) {
  return request({
    url: '/goodsXunjia/goodsXunjia/add',
    method: 'post',
    data: data
  })
}

// 修改商品
export function updateGoods(data) {
  return request({
    url: '/goodsXunjia/goodsXunjia/edit',
    method: 'post',
    data: data
  })
}

// 删除商品
export function delGoods(data) {
  return request({
    url: '/goodsXunjia/goodsXunjia/delete',
    method: 'post',
    data: data
  })
}


export function batchOn(data) {
  return request({
    url: '/goodsXunjia/goodsXunjia/batchOn',
    method: 'post',
    data: data
  })
}


export function batchOff(data) {
  return request({
    url: '/goodsXunjia/goodsXunjia/batchOff',
    method: 'post',
    data: data
  })
}

export function batchCopy(data) {
  return request({
    url: '/goodsXunjia/goodsXunjia/copy',
    method: 'post',
    data: data
  })
}

// 查询商品库存详细
export function getGoodsStock(data) {
  return request({
    url: '/goods/goods/detail/xunjia/stock',
    method: 'get',
    params: data
  })
}
export function updateGoodsStock(data) {
  return request({
    url: '/goods/goods/edit/xunjia/stock',
    method: 'post',
    data: data
  })
}